module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADJSURBVHgBrZLBEcIgEEX/Ym5eUoIt5OI9FWgHagVOKtB0kBK0Eu9WkRJycLzJuuvADDERw+g/AAu8z7IA/CjSZlnzxgKNBPlErpW9x+uBzkYjliABVi2EaXRg/ATSlYcGSWJCJV2r4wypYuzkVGaXdVoGAhO94JOfMsFiQS6tqXDfwGBvGOWoyQdYlQWbtg+xm1mUlnDxd4zBfYMxE0Ydg4cGgcncorgTVjF43MCZ3AjrKb/TF7F7X/gG+2Ibd2IVfcKhOq0P/qEnE/lG2WpVEUsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/sourceFile/check_is.png
// module id = rWkL
// module chunks = 4